import { FieldValues } from "react-hook-form";
import { Step } from "./Step";
import { StepperProps } from "./types";
import LoadingSpinner from "../LoadingSpinner";

export const Stepper = <T extends FieldValues>({
  activeStep,
  onSkip,
  onNext,
  onBack,
  isLoading = false,
  steps,
  isNextButtonLoading = false,
  onStepOptionSelect,
  onItemHover,
  size,
  isPreview,
  onExit,
}: StepperProps<T>) => {
  const totalSteps = steps?.filter((item) => !item.isOptional).length;

  if (!steps) return null;

  return (
    <>
      {isLoading && (
        <div className="absolute left-1/2 top-1/2 z-10 flex h-full w-full -translate-x-1/2 -translate-y-1/2 items-center justify-center">
          <div className="absolute inset-0 bg-gray-50/30 backdrop-blur-sm" />
          <LoadingSpinner className="h-4 w-4" />
        </div>
      )}
      <Step
        size={size}
        isPreview={isPreview}
        onItemHover={onItemHover}
        onExit={onExit}
        stepNumber={activeStep + 1}
        step={steps[activeStep]}
        totalSteps={totalSteps}
        onStepOptionSelect={onStepOptionSelect}
        onBack={() => onBack(activeStep)}
        onNext={() => onNext(activeStep)}
        onSkip={onSkip}
        isNextButtonLoading={isNextButtonLoading}
      />
    </>
  );
};
